import React from "react";
import ContactsList from "../components/ContactList/ContactList";
import Container from "../components/Container/Container";

const Contacts: React.FC = () => {
  return (
    <Container>
      <ContactsList />
    </Container>
  );
};

export default Contacts;
